import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import LoginModal from "@/components/LoginModal";
import SignupModal from "@/components/SignupModal";

interface AuthModalsContextType {
  openLogin: () => void;
  openSignup: () => void;
}

const AuthModalsContext = createContext<AuthModalsContextType>({
  openLogin: () => {},
  openSignup: () => {},
});

export const useAuthModals = () => useContext(AuthModalsContext);

export const AuthModalsProvider = ({ children }: { children: ReactNode }) => {
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);
  const { user } = useAuth();

  // Close modals when user signs in (handles OAuth/magic link)
  useEffect(() => {
    if (user) {
      setLoginOpen(false);
      setSignupOpen(false);
    }
  }, [user]);

  return (
    <AuthModalsContext.Provider value={{ openLogin: () => setLoginOpen(true), openSignup: () => setSignupOpen(true) }}>
      {children}
      <LoginModal open={loginOpen} onOpenChange={setLoginOpen} onSwitchToSignup={() => { setLoginOpen(false); setSignupOpen(true); }} />
      <SignupModal open={signupOpen} onOpenChange={setSignupOpen} onSwitchToLogin={() => { setSignupOpen(false); setLoginOpen(true); }} />
    </AuthModalsContext.Provider>
  );
};
